import { IconSvg, IconSvgProps } from "./icon"

export default function Cog(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="m9.724 5.893.553-1.427a1.286 1.286 0 0 1 1.196-.823h1.054a1.286 1.286 0 0 1 1.196.823l.553 1.427 1.877 1.08 1.517-.232a1.285 1.285 0 0 1 1.286.63l.514.9a1.285 1.285 0 0 1-.103 1.453l-.939 1.196v2.16l.965 1.196a1.285 1.285 0 0 1 .103 1.453l-.515.9a1.286 1.286 0 0 1-1.285.63l-1.518-.232-1.877 1.08-.553 1.427a1.285 1.285 0 0 1-1.195.823h-1.08a1.286 1.286 0 0 1-1.196-.823l-.553-1.427-1.877-1.08-1.517.232a1.285 1.285 0 0 1-1.286-.63l-.514-.9a1.286 1.286 0 0 1 .103-1.453l.938-1.196v-2.16l-.964-1.196a1.286 1.286 0 0 1-.103-1.453l.515-.9a1.286 1.286 0 0 1 1.285-.63l1.517.232 1.903-1.08ZM9.43 12a2.571 2.571 0 1 0 5.142 0 2.571 2.571 0 0 0-5.142 0Z" />
    </IconSvg>
  )
}
